import { makeAutoObservable } from 'mobx'
import { mx } from 'store/base/mx'
import { Item } from 'type/Item'

export class BuyModalStore {
  readonly item: Item
  readonly show_name: boolean

  constructor(item: Item, show_name: boolean) {
    makeAutoObservable(this)
    this.item = item
    this.show_name = show_name
  }
}

export const buyModal = mx.ref<BuyModalStore>()
